/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line 
  
  // Sticky header visible on scroll
  document.addEventListener("DOMContentLoaded", function () {
      let lastScrollTop = 0;
      const header = document.querySelector(".theme__header");
      const scrollThreshold = 400; // Seuil de déclenchement
  
      header.classList.add("is-visible");
  
      setTimeout(() => {
          header.classList.add("transition-active");
      }, 100);
  
      window.addEventListener("scroll", function () {
          let scrollTop = window.scrollY;
  
          if (scrollTop < scrollThreshold) {
              header.classList.add("is-visible");
          } else {
              if (scrollTop > lastScrollTop) {
                  header.classList.remove("is-visible");
              } else {
                  header.classList.add("is-visible");
              }
          }
  
          lastScrollTop = scrollTop;
      });
  });

  // Header → Popup pour la translation (langue + currency)
document.addEventListener("DOMContentLoaded", function () {
  const desktopTrigger = document.querySelector(".translation-trigger:not(.mobile-trigger)");
  const desktopPopup = document.querySelector(".translation-popup:not(.popup-mobile)");

  const mobileTrigger = document.querySelector(".translation-trigger.mobile-trigger");
  const mobilePopup = document.querySelector(".translation-popup.popup-mobile");

  const desktopClose = desktopPopup?.querySelector(".translation-popup-close");
  const mobileClose = mobilePopup?.querySelector(".translation-popup-close");

  // Fonction pour gérer l'ouverture/fermeture de popup
  function togglePopup(trigger, popup, closeBtn) {
    if (!trigger || !popup) return;

    trigger.addEventListener("click", function (e) {
      e.stopPropagation();
      popup.classList.toggle("active");
    });

    document.addEventListener("click", function (e) {
      if (!popup.contains(e.target) && !trigger.contains(e.target)) {
        popup.classList.remove("active");
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener("click", function () {
        popup.classList.remove("active");
      });
    }
  }

  togglePopup(desktopTrigger, desktopPopup, desktopClose);
  togglePopup(mobileTrigger, mobilePopup, mobileClose);
});



  //Panier Ouvrir le last accordion des upsell 
    document.addEventListener("DOMContentLoaded", function () {
    const cartDrawer = document.querySelector(".drawer--cart");
  
    if (!cartDrawer) return; // Sécurité : si le panier n'existe pas, on arrête
  
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (cartDrawer.classList.contains("is-open")) {
          updateAccordions();
        }
      });
    });
  
    observer.observe(cartDrawer, { attributes: true, attributeFilter: ["class"] });
  
    function updateAccordions() {
      const accordions = document.querySelectorAll(".upsell-products__container-last-item");
      
      if (accordions.length === 0) return;
  
      // Fermer tous les accordéons
      accordions.forEach((acc) => acc.removeAttribute("open"));
  
      // Ouvrir uniquement le dernier accordéon
      const lastAccordion = accordions[accordions.length - 1];
      if (lastAccordion) {
        lastAccordion.setAttribute("open", "true");
      }
    }
  });

  // Guide entretien / Sidebar avec menu sticky en fonction du header
  document.addEventListener("DOMContentLoaded", function () {
      const header = document.querySelector(".theme__header");
      const sidebarParent = document.querySelector(".vertical_sidebar"); // Vérifier si le parent existe
  
      if (!sidebarParent) return; // Si le parent n'existe pas, on arrête le script
  
      const sidebar = sidebarParent.querySelector(".section-sidebar__aside"); // Sélectionne l'élément enfant
  
      if (!sidebar) return; // Si l'enfant n'existe pas, on arrête aussi
  
      function updateSidebarPosition() {
          const headerHeight = header.offsetHeight; // Récupère la hauteur du header
          const isHeaderVisible = header.classList.contains("is-visible");
  
          // Ajuste le `top` du sidebar en fonction de la visibilité du header
          sidebar.style.top = isHeaderVisible ? `${headerHeight}px` : "0px";
      }
  
      // Observer les classes du header pour ajuster la position du sidebar
      const observer = new MutationObserver(updateSidebarPosition);
      observer.observe(header, { attributes: true, attributeFilter: ["class"] });
  
      // Ajuster aussi lors du chargement
      updateSidebarPosition();
  });
  
  // Guide entretien / Ajouter la class MARKER aux items en cours de lecture
  document.addEventListener("DOMContentLoaded", function () {
      const titles = document.querySelectorAll("h2.section-sidebar__title"); // Tous les titres H2
      const buttons = document.querySelectorAll(".widget__links .widget__link"); // Boutons dans la top bar
      const sidebarNav = document.querySelector(".widget__links"); // Conteneur scrollable
  
      function updateActiveButton() {
          let firstVisibleTitle = null;
  
          // Trouver le premier titre H2 visible à l'écran
          titles.forEach((title) => {
              const rect = title.getBoundingClientRect();
  
              if (rect.top >= 0 && rect.bottom <= window.innerHeight) { // H2 visible
                  if (!firstVisibleTitle || rect.top < firstVisibleTitle.getBoundingClientRect().top) {
                      firstVisibleTitle = title; // Garde le plus haut titre visible
                  }
              }
          });
  
          // Mettre à jour les boutons
          buttons.forEach((button) => {
              if (firstVisibleTitle && button.getAttribute("data-scroll-to") === `#${firstVisibleTitle.id}`) {
                  button.classList.add("MARKER");
  
                  // Scroll horizontal pour rendre visible le bouton actif
                  if (sidebarNav) {
                      sidebarNav.scrollTo({
                          left: button.offsetLeft - sidebarNav.offsetWidth / 2 + button.offsetWidth / 2,
                          behavior: "smooth"
                      });
                  }
  
              } else {
                  button.classList.remove("MARKER");
              }
          });
      }
  
      window.addEventListener("scroll", updateActiveButton);
      updateActiveButton(); // Exécuter une première fois au chargement
  });

  
  // Mega menu / Display image on navlink--grandchild hover
  document.querySelectorAll('.header__dropdown').forEach(grandparent => {
  grandparent.addEventListener('mouseenter', function() {
      if (!this.classList.contains('is-visible')) return;
  
      const megaMenu = this.querySelector('.header__dropdown__inner'); // Le conteneur du méga-menu spécifique
      if (!megaMenu) return;
  
      megaMenu.querySelectorAll('.navlink--grandchild').forEach(navlink => {
          navlink.addEventListener('mouseenter', function() {
              const index = String(Number(this.dataset.index)).padStart(2, '0');
  
              // Cacher toutes les images dans CE méga-menu seulement
              megaMenu.querySelectorAll('.nav--mega-single-image').forEach(img => {
                  img.classList.add('no-opacity');
              });
  
              // Afficher l'image correspondante
              const imageToShow = megaMenu.querySelector(`.nav--mega-single-image-${index}`);
              if (imageToShow) {
                  imageToShow.classList.remove('no-opacity');
              }
          });
  
          navlink.addEventListener('mouseleave', function() {
              // Cacher toutes les images dans CE méga-menu seulement
              megaMenu.querySelectorAll('.nav--mega-single-image').forEach(img => {
                  img.classList.add('no-opacity');
              });
          });
      });
  });
  });

  // Page produit / BOUTON PLAY/PAUSE DE LA VIDEO SUR LE SLIDER VERSION MOBILE
  document.addEventListener("DOMContentLoaded", function () {
    function addCustomControls() {
      const video = document.querySelector("deferred-media video");
      const controlsContainer = document.querySelector(".play_pause__btns");
  
      if (video && controlsContainer && !controlsContainer.hasChildNodes()) {
        console.log("Vidéo détectée, ajout du bouton...");
  
        // Création du bouton Play/Pause
        const button = document.createElement("button");
        button.classList.add("video-play-button");
        const icon = document.createElement("img");
        icon.src = "https://cdn.shopify.com/s/files/1/0933/3194/7784/files/btn_play_dark_grey.png"; // Image Play
        icon.alt = "Play";
        icon.classList.add("play-icon");
        button.appendChild(icon);
  
        // Ajout du bouton dans la div play_pause__btns
        controlsContainer.appendChild(button);
  
        // Gestion du Play/Pause
        button.addEventListener("click", function () {
          if (video.paused) {
            video.play();
            icon.src = "https://cdn.shopify.com/s/files/1/0933/3194/7784/files/btn_pause_dark_grey.png"; // Image Pause
            icon.alt = "Pause";
          } else {
            video.pause();
            icon.src = "https://cdn.shopify.com/s/files/1/0933/3194/7784/files/btn_play_dark_grey.png"; // Image Play
            icon.alt = "Play";
          }
        });
  
        // Changer l'image quand la vidéo joue ou est en pause
        video.addEventListener("play", function () {
          icon.src = "https://cdn.shopify.com/s/files/1/0933/3194/7784/files/btn_pause_dark_grey.png"; // Image Pause
          icon.alt = "Pause";
        });
  
        video.addEventListener("pause", function () {
          icon.src = "https://cdn.shopify.com/s/files/1/0933/3194/7784/files/btn_play_dark_grey.png"; // Image Play
          icon.alt = "Play";
        });
      }
    }
  
    // Attendre que le contenu différé soit chargé
    const deferredMedia = document.querySelector("deferred-media");
    if (deferredMedia) {
      const observer = new MutationObserver(addCustomControls);
      observer.observe(deferredMedia, { childList: true, subtree: true });
    }
  
    // Essayer d'ajouter les contrôles immédiatement si la vidéo est déjà chargée
    addCustomControls();
  });


    // PAGE PRODUIT / Afficher l'image produit avec Pieces de bout
    const target = document.querySelector('.oz__option-element-checkbox');
    const productImage = document.querySelector('.product__image-pdb');
    
    function updateDisplay() {
      if (target.classList.contains('oz__option-value--selected')) {
        productImage.style.display = 'block';
      } else {
        productImage.style.display = 'none';
      }
    }
    
    const observer = new MutationObserver(updateDisplay);
    
    // Configurer l'observateur pour écouter les attributs (dont les classes)
    observer.observe(target, { attributes: true, attributeFilter: ['class'] });
    
    // Appel initial (au cas où la classe est déjà là au chargement)
    updateDisplay();

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


